module.exports = __webpack_public_path__ + "static/img/contant_7.3148424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_7.jpg
// module id = XWTP
// module chunks = 0